<template>
  <div>
    <div>
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="card-title">Contract Issues</h4>
          <span class="badge badge-success" style="float: right"
            >Total: {{ issues.total }}</span
          >
        </div>
        <div class="card-content">
          <div class="card-body pb-1">
            <div class="row align-items-center justify-content-center mt-2">
              <div class="col-12">
                <div
                  id="contract-issues-chart"
                  class="d-flex justify-content-center"
                ></div>
              </div>
            </div>

            <div class="row mt-2 mb-1">
              <div class="col-md-6 col-sm-12">
                <strong>Urgent: </strong>
              </div>
              <div class="col-md-6 col-sm-12 justify-content-end d-flex">
                <span class="badge badge-danger" v-if="issues.totalUrgent">
                  {{ issues.totalUrgent }} - ({{
                    (issues.totalUrgent / issues.total).toFixed(2)
                  }}
                  Per Contract)
                </span>
              </div>
            </div>

            <div class="row mt-2 mb-1">
              <div class="col-md-6 col-sm-12">
                <strong>Non Urgent: </strong>
              </div>
              <div class="col-md-6 col-sm-12 justify-content-end d-flex">
                <span class="badge badge-warning" v-if="issues.totalNonUrgent">
                  {{ issues.totalNonUrgent }} - ({{
                    (issues.totalNonUrgent / issues.total).toFixed(2)
                  }}
                  Per Contract)
                </span>
              </div>
            </div>

            <div class="row mt-2 mb-1">
              <div class="col-md-6 col-sm-12">
                <strong>Resolved Urgent: </strong>
              </div>
              <div class="col-md-6 col-sm-12 justify-content-end d-flex">
                <span
                  class="badge badge-primary"
                  v-if="issues.totalResolvedUrgent"
                >
                  {{ issues.totalResolvedUrgent }}
                </span>
              </div>
            </div>

            <div class="row mt-2 mb-1">
              <div class="col-md-6 col-sm-12">
                <strong>Resolved Non Urgent: </strong>
              </div>
              <div class="col-md-6 col-sm-12 justify-content-end d-flex">
                <span
                  class="badge badge-primary"
                  v-if="issues.totalResolvedNonUrgent"
                >
                  {{ issues.totalResolvedNonUrgent }}
                </span>
              </div>
            </div>

            <hr />

            <div class="row mt-2 mb-1">
              <div class="col-md-6 col-sm-12">
                <strong>Time To Resolve Urgent: </strong>
              </div>
              <div class="col-md-6 col-sm-12 justify-content-end d-flex">
                <span
                  class="badge badge-primary"
                  v-if="issues.averageTTRUrgentMins"
                >
                  {{ issues.averageTTRUrgentMins }} (minutes)
                </span>
              </div>
            </div>

            <div class="row mt-2 mb-1">
              <div class="col-md-6 col-sm-12">
                <strong>Time To Resolve Non Urgent: </strong>
              </div>
              <div class="col-md-6 col-sm-12 justify-content-end d-flex">
                <span
                  class="badge badge-primary"
                  v-if="issues.averageTTRNonUrgentMins"
                >
                  {{ issues.averageTTRNonUrgentMins }} (minutes)
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts';

export default {
  props: ["issues"],
  methods: {
    initPaymentsChart() {
      const donutChartOption = {
        chart: {
          width: 200,
          type: "donut",
        },
        dataLabels: {
          enabled: false,
        },
        series: [],
        labels: [],
        stroke: {
          width: 0,
          lineCap: "round",
        },
        colors: ["#00CFDD", "#FDAC41", "#5A8DEE", "#39DA8A"],
        plotOptions: {
          pie: {
            donut: {
              size: "90%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "15px",
                  colors: "#596778",
                  offsetY: 20,
                  fontFamily: "IBM Plex Sans",
                },
                value: {
                  show: true,
                  fontSize: "26px",
                  fontFamily: "Rubik",
                  color: "#475f7b",
                  offsetY: -20,
                  formatter: function (val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#828D99",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce(function (a, b) {
                      return a + b;
                    }, 0);
                  },
                },
              },
            },
          },
        },
        legend: {
          show: false,
        },
      };

      const donutChart = new ApexCharts(
        document.querySelector("#contract-issues-chart"),
        donutChartOption
      );

      this.issues.statuses.counts.forEach((type) => {
        for (const [key, value] of Object.entries(type)) {
          donutChartOption.labels.push(key.replaceAll("_", " "));
          donutChartOption.series.push(value);
        }
      });

      donutChart.render();
    },
  },

  mounted() {
    this.initPaymentsChart();
  },
};
</script>

